module.exports = __webpack_public_path__ + "static/img/transforma-tu-aventura-3.4eca580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/transforma-tu-aventura-3.jpg
// module id = vlls
// module chunks = 1